module.exports = __webpack_public_path__ + "media/images/emblems/Ilanz_wappen-fa2788397fdab10b869ea6e3e89bbedd.svg";